module.exports = __webpack_public_path__ + "static/media/negativeLogo.7def951f.svg";